<section class="mixed-hover-chart" [style.height]="data?.height || '100%'">
  <div class="mixed-hover-chart__canvas" #chartContainer></div>
</section>
